import { useRequiredContext } from "@redotech/react-util/context";
import { LoadState, useLoad } from "@redotech/react-util/load";
import { InteractiveMapLocation } from "@redotech/redo-model/draft-return/draft-return";
import { RpcClientContext } from "../../contexts/rpc";
import { CustomerPortalAppSettings } from "../../settings";

export interface InStoreLocationsResponse {
  locationsLoad: LoadState<InteractiveMapLocation[]>;
}

export const useInStoreLocations = (
  draftReturnId: string | undefined,
  returnId: string | undefined,
  settings: CustomerPortalAppSettings | undefined,
) => {
  const client = useRequiredContext(RpcClientContext);
  const locationsLoad: LoadState<InteractiveMapLocation[]> =
    useLoad(async () => {
      if (!draftReturnId && !returnId) {
        return [];
      }
      const { locations } = await client.getLocations({
        draftReturnId,
        returnId,
      });
      return locations ?? [];
    }, [draftReturnId, returnId]);

  return { locationsLoad };
};
